module.exports = __webpack_public_path__ + "static/img/equityImg0.png";